export default "__VITE_ASSET__CHQiMbEG__"